import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: 0,
  schoolID: '',
  teacherID: '',
  gradeMap: '',
  refreshPage: false,
  school_id_d: '',
  openFeeConfirm: false,
  searchItem: '',
  SchoolDInfo: [],
  loader: false,
  employee_ID: '',
  rowsPerPage: 25,
  page: 0,
  studentID: '',
  selectedRow: [],
  anchorEl: null,
  openImport: false,
  expenseID: '',
  sectionId: '',
  openSection: false,
  isAuthenticated: false,
  inExpense: false,
  vanID: null,
  passengerSchoolID: null,
  creditOpen: false,
  holiday_id: '',
  choosedRow: [],
  isEdit: false,
  StopId: '',
  exam_fees: 0,
  openTransportModal: false,
  openExportModal: false,
  openFeeCollection: false,
  openAddNewTimeTable: false,
  openAddTime: false,
  // openFeeConfirm:true,
  openCollectedFeeConfirm: false,
  openExportModalFee: false,
  openExportIndividualFee: false,
  classSteps: 1,
  openAddClass: false,
  openAddSubject: false,
  openIndividualStudent: false,
  openIndividualTeacher: false,
  selectedFilter: 'Summary',
}

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1
    },
    setVanID: (state, action) => {
      state.vanID = action.payload
    },
    setPassengerSchoolID: (state, action) => {
      state.passengerSchoolID = action.payload
    },
    setInExpense: (state, action) => {
      state.inExpense = action.payload
    },
    setSectionID: (state, action) => {
      state.sectionId = action.payload
    },
    setOpenImport: (state, action) => {
      state.openImport = action.payload
    },
    setSearchItem: (state, action) => {
      state.searchItem = action.payload
    },
    setAnchorEl: (state, action) => {
      state.anchorEl = action.payload
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload
    },
    setRefreshPage: (state, action) => {
      state.refreshPage = action.payload
    },
    setOpenFeeConfirm: (state, action) => {
      state.openFeeConfirm = action.payload
    },
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload
    },
    setChoosedRow: (state, action) => {
      state.choosedRow = action.payload
    },
    setSchoolID: (state, action) => {
      state.schoolID = action.payload
    },
    setEmployeeID: (state, action) => {
      state.employee_ID = action.payload
    },
    setSchoolDID: (state, action) => {
      state.school_id_d = action.payload
    },
    setTeacherID: (state, action) => {
      state.teacherID = action.payload
    },
    setGradeMap: (state, action) => {
      state.gradeMap = action.payload
    },
    setSchoolDInfo: (state, action) => {
      state.SchoolDInfo = action.payload
    },
    setLoader: (state, action) => {
      state.loader = action.payload
    },
    setPage: (state, action) => {
      state.page = action.payload
    },
    setStudentID: (state, action) => {
      state.studentID = action.payload
    },
    setExpenseID: (state, action) => {
      state.expenseID = action.payload
    },
    setSectionOpen: (state, action) => {
      state.openSection = action.payload
    },
    setisAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload
    },
    setCreditOpen: (state, action) => {
      state.creditOpen = action.payload
    },
    setHolidayId: (state, action) => {
      state.holiday_id = action.payload
    },
    setIsEdit: (state, action) => {
      state.isEdit = action.payload
    },
    setStopID: (state, action) => {
      state.StopId = action.payload
    },
    setExamFees: (state, action) => {
      state.exam_fees = action.payload
    },
    setOpenTransportModal: (state, action) => {
      state.openTransportModal = action.payload
    },
    setOpenExportModal: (state, action) => {
      state.openExportModal = action.payload
    },
    setOpenFeeCollection: (state, action) => {
      state.openFeeCollection = action.payload
    },
    // setOpenAddNewTimeTable: (state, action) => {
    //   state.openAddNewTimeTable = action.payload
    // },
    setOpenAddNewTimeTable: (state, action) => {
      state.openAddNewTimeTable = action.payload
    },
    setOpenAddTime: (state, action) => {
      state.openAddTime = action.payload
    },
    setOpenCollectedFeeConfirm: (state, action) => {
      state.openCollectedFeeConfirm = action.payload
    },
    setOpenExportModalFee: (state, action) => {
      state.openExportModalFee = action.payload
    },
    setOpenExportModalIndividualFee: (state, action) => {
      state.openExportIndividualFee = action.payload
    },
    setClassSteps: (state, action) => {
      state.classSteps = action.payload
    },
    setOpenAddClass: (state, action) => {
      state.openAddClass = action.payload
    },
    setOpenAddSubject: (state, action) => {
      state.openAddSubject = action.payload
    },
    setOpenIndividualStudent: (state, action) => {
      state.openIndividualStudent = action.payload
    },
    setOpenIndividualTeacher: (state, action) => {
      state.openIndividualTeacher = action.payload
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload
    },
  },
})

export const {
  setSelectedFilter,
  setOpenIndividualTeacher,
  setOpenIndividualStudent,
  setOpenAddSubject,
  setOpenAddClass,
  setClassSteps,
  setOpenExportModalIndividualFee,
  setOpenExportModalFee,
  setOpenCollectedFeeConfirm,
  setOpenAddTime,
  setOpenAddNewTimeTable,
  setOpenTransportModal,
  setOpenFeeCollection,
  increment,
  setVanID,
  setPassengerSchoolID,
  setInExpense,
  setisAuthenticated,
  setSectionID,
  setExpenseID,
  setAnchorEl,
  setSelectedRow,
  setSearchItem,
  setPage,
  setStudentID,
  setOpenFeeConfirm,
  setSchoolDID,
  setRefreshPage,
  setSchoolID,
  setTeacherID,
  setGradeMap,
  setSchoolDInfo,
  setLoader,
  setStopID,
  setEmployeeID,
  setRowsPerPage,
  setOpenImport,
  setSectionOpen,
  setCreditOpen,
  setHolidayId,
  setChoosedRow,
  setIsEdit,
  setExamFees,
  setOpenExportModal,
} = globalSlice.actions

export default globalSlice.reducer
